import styled from 'styled-components';

const Mobile = styled.div`
  @media screen and (min-width: 1024px) {
    display: none;
  }
`;
export default Mobile;
